const EmptyAccountListIcon = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='244' height='124' viewBox='0 0 244 124' fill='none'>
			<g filter='url(#filter0_d_6234_108068)'>
				<path
					d='M34 51C34 46.5817 37.5817 43 42 43H202C206.418 43 210 46.5817 210 51V90C210 94.4183 206.418 98 202 98H42C37.5817 98 34 94.4183 34 90V51Z'
					fill='white'
				/>
			</g>
			<g filter='url(#filter1_d_6234_108068)'>
				<path
					d='M22 45C22 39.4772 26.4772 35 32 35H212C217.523 35 222 39.4772 222 45V80C222 85.5228 217.523 90 212 90H32C26.4772 90 22 85.5228 22 80V45Z'
					fill='white'
				/>
			</g>
			<g filter='url(#filter2_d_6234_108068)'>
				<path
					d='M10 38C10 31.3726 15.3726 26 22 26H222C228.627 26 234 31.3726 234 38V70C234 76.6274 228.627 82 222 82H22C15.3726 82 10 76.6274 10 70V38Z'
					fill='white'
				/>
			</g>
			<path
				d='M66 44C66 41.7909 67.7909 40 70 40H126C128.209 40 130 41.7909 130 44C130 46.2091 128.209 48 126 48H70C67.7909 48 66 46.2091 66 44Z'
				fill='#96A4B5'
				fillOpacity='0.16'
			/>
			<rect x='22' y='38' width='14' height='14' rx='4' fill='#96A4B5' fillOpacity='0.16' />
			<rect x='22' y='56' width='14' height='14' rx='4' fill='#96A4B5' fillOpacity='0.16' />
			<rect x='40' y='56' width='6' height='6' rx='3' fill='#96A4B5' fillOpacity='0.16' />
			<rect x='40' y='64' width='6' height='6' rx='3' fill='#96A4B5' fillOpacity='0.16' />
			<rect x='48' y='56' width='6' height='6' rx='3' fill='#96A4B5' fillOpacity='0.16' />
			<rect x='48' y='64' width='6' height='6' rx='3' fill='#96A4B5' fillOpacity='0.16' />
			<rect x='40' y='38' width='14' height='14' rx='4' fill='#96A4B5' fillOpacity='0.16' />
			<path
				d='M66 60C66 57.7909 67.7909 56 70 56H218C220.209 56 222 57.7909 222 60V64C222 66.2091 220.209 68 218 68H70C67.7909 68 66 66.2091 66 64V60Z'
				fill='#96A4B5'
				fillOpacity='0.2'
			/>
			<defs>
				<filter
					id='filter0_d_6234_108068'
					x='24'
					y='38'
					width='196'
					height='75'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='5' />
					<feGaussianBlur stdDeviation='5' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_6234_108068' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_6234_108068' result='shape' />
				</filter>
				<filter
					id='filter1_d_6234_108068'
					x='12'
					y='30'
					width='220'
					height='75'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='5' />
					<feGaussianBlur stdDeviation='5' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_6234_108068' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_6234_108068' result='shape' />
				</filter>
				<filter
					id='filter2_d_6234_108068'
					x='0'
					y='21'
					width='244'
					height='76'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='5' />
					<feGaussianBlur stdDeviation='5' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_6234_108068' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_6234_108068' result='shape' />
				</filter>
			</defs>
		</svg>
	);
};

export default EmptyAccountListIcon;
